import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment-timezone';
import {
  containerQueryProps,
  Link,
  TranslationProvider,
  useAnalytics,
} from '@resy/ui-kitchen';

import './BlogPost.scss';
import { EVENT_TYPE } from '../../../../../../ui-kitchen/src/components/Announcement/announcementTypes';

const BlogPost = (props) => {
  const {
    author_display_name: authorName,
    className,
    image,
    name,
    post_date: postDate,
    tagUrl,
    title,
    url,
    containerQuery: { md, lg, xl },
    id,
    isContentTile,
  } = props;

  const [isAnnouncementViewed, setIsAnnouncementViewed] = useState(false);
  const Analytics = useAnalytics();

  useEffect(() => {
    if (!isAnnouncementViewed && isContentTile && Analytics?.event) {
      Analytics.event(EVENT_TYPE.VIEW_ANNOUNCEMENT, {
        context: 'homepage',
        type: 'content tile',
        title,
        id,
      });
      setIsAnnouncementViewed(true);
    }
  }, [isAnnouncementViewed, id, title]);

  const handleClick = () => {
    if (isContentTile && Analytics?.event) {
      Analytics.event(EVENT_TYPE.CLICK_ANNOUNCEMENT, {
        context: 'homepage',
        type: 'content tile',
        title,
        id,
      });
    }
  };

  return (
    <div className={cx({
      [className]: typeof className !== 'undefined',
    })}
    >
      <Link
        className={cx('BlogPost', {
          'BlogPost--md': md,
          'BlogPost--lg': lg,
          'BlogPost--xl': xl,
        })}
        href={url}
        aria-label={title}
        tabIndex="-1"
        variant="article"
        onClick={handleClick}
      >
        <div
          className={cx('BlogPost__Image', {
            'BlogPost__Image--md': md,
            'BlogPost__Image--lg': lg,
            'BlogPost__Image--xl': xl,
          })}
          style={{
            backgroundImage: `url(${image})`,
          }}
        />
      </Link>

      <div className="BlogPost__Content">
        <Link
          className={cx('BlogPost__Tag skeleton', {
            'no-skeleton': !!name,
          })}
          href={tagUrl}
          variant="article"
          onClick={handleClick}
        >
          {name}
        </Link>
        <Link
          className="BlogPost__Title"
          href={url}
          aria-label={title}
          variant="article"
          onClick={handleClick}
        >
          <h2
            className={cx('BlogPost__Title skeleton', {
              'no-skeleton': !!title,
            })}
          >
            {title}
          </h2>
        </Link>
        {authorName
          && (
            <div className="BlogPost__author">
              <TranslationProvider translationKey="by_author" translationValues={{ author: authorName }}>
                <span className="BlogPost__author-translated">
                  {`By ${authorName}`}
                </span>
              </TranslationProvider>
              <span>&nbsp; &middot; &nbsp;</span>
              {moment(postDate).format('LL')}
            </div>
          )}
      </div>
    </div>
  );
};

BlogPost.propTypes = {
  author_display_name: PropTypes.string,
  className: PropTypes.string,
  containerQuery: containerQueryProps,
  image: PropTypes.string,
  name: PropTypes.string,
  post_date: PropTypes.string,
  tagUrl: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  id: PropTypes.number,
  isContentTile: PropTypes.bool,
};

BlogPost.defaultProps = {
  author_display_name: undefined,
  className: undefined,
  containerQuery: {},
  image: '',
  name: '',
  post_date: undefined,
  tagUrl: '',
  title: '',
  url: '',
  id: undefined,
  isContentTile: false,
};

BlogPost.displayName = 'BlogPost';
export default BlogPost;
